import { render, staticRenderFns } from "./samut-prakan.vue?vue&type=template&id=5c28a729&scoped=true"
import script from "./samut-prakan.vue?vue&type=script&lang=js"
export * from "./samut-prakan.vue?vue&type=script&lang=js"
import style0 from "./samut-prakan.vue?vue&type=style&index=0&id=5c28a729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c28a729",
  null
  
)

export default component.exports